import { AxiosPromise, AxiosResponse } from 'axios';
import { apiService, manageFilters } from '@app/services';
import { IActiveFilter } from '@app/models';

class SyncService {
    readonly apiBase: string = '/api/directory/AgentProfiles';
    readonly dirsync: string = '/api/v1/agentservice/agent/dirsync';

    getSyncs(orderBy: string, asc: string, top: number, skip: number, organizationId: string, filters?: IActiveFilter[]): AxiosPromise {
        return apiService.get(`${this.apiBase}/GetDirSyncAgentProfiles`, {
            params: {
                $orderBy: orderBy + ' ' + asc,
                $top: top,
                $skip: skip,
                $count: true,
                ...(filters ? { $filter: manageFilters(filters, organizationId) } : { $filter: manageFilters([], organizationId) })
            }
        })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    getSyncAgent(agentId: string) {
        return apiService.get(`${this.apiBase}(${agentId})`)
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    getSyncAgentAttributeMap(agentId: string) {
        return apiService.get(`${this.apiBase}(${agentId})/AgentProfileAttributeMap`)
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    getSyncAgentOUNode(agentId: string) {
        return apiService.post(`${this.apiBase}(${agentId})/GetOUNode?$expand=Children`,
            {
                'parentPath': null, 'ouNodeName': null
            }
        )
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    updateSyncAgentOUNode(jsonObject: any, agentId: string) {
        return apiService.post(`${this.apiBase}(${agentId})/UpdateOUNode`, jsonObject)
            .catch();
    }

    getSyncAgentDownloadLocation() {
        return apiService.get('/api/dirsync')
            .catch();
    }

    getNewSyncAgent(handleSuccess: Function) {
        return apiService.get(`${this.apiBase}/GetNewAgent`,
            {
                onSuccess: handleSuccess,
                // polling API, error is transient so we should still keep polling
                onError: handleSuccess
            })
            .catch();
    }

    putSyncAgent(syncAgentObject: any, agentId: string, handleSuccess: Function, handleError: Function) {
        return apiService.put(`${this.apiBase}(${agentId})`, syncAgentObject,
            {
                onSuccess: handleSuccess,
                onError: handleError
            })
            .catch();
    }

    deleteSyncAgent(jsonObject: any, handleError: Function, handleSuccess: Function): AxiosPromise {
        const apiUrl: string = `${this.apiBase}/DeleteProfiles`;

        return apiService.post(apiUrl,
            jsonObject,
            { onError: handleError, onSuccess: handleSuccess })
            .catch();
    }

    getAUSISyncAgent(agentId: string) {
        return apiService.get(`${this.dirsync}/(${agentId})`, {dirSinc: true})
        .catch((error: AxiosResponse) => Promise.reject(error));
    }

    addAUSISyncAgent(syncAUSIAgentObject: any, handleSuccess: Function, handleError: Function) {
        return apiService.post(`${this.dirsync}`, syncAUSIAgentObject,
            {
                onSuccess: handleSuccess,
                onError: handleError,
                dirSinc: true
            })
        .catch();
    }

    startFullSync(clientId: any) {
        return apiService.post(`${this.dirsync}/${clientId}/sync`).catch();
    }

    patchAUSISyncAgent(syncAUSIAgentObject: any, agentId: number, handleSuccess: Function, handleError: Function) {
        return apiService.put(`${this.dirsync}/(${agentId})`, syncAUSIAgentObject,
            {
                onSuccess: handleSuccess,
                onError: handleError,
                dirSinc: true
            })
        .catch();
    }

    deleteAUSISyncAgents(agentIds: string[], handleSuccess: Function, handleError: Function) {
        return apiService.delete(`${this.dirsync}`, {
            data: {ids: agentIds},
            onSuccess: handleSuccess,
            onError: handleError,
            dirSinc: true
        })
        .catch();
    }
}

export const syncService = new SyncService();